<mat-form-field *ngIf="field.fieldType === 'date'" class="form-field" [formGroup]="group"
  [ngStyle]="field.containerStyles" [color]="field.color">
  <input matInput [gioEnableControl]="isEnabledFn(field.name, field.id)" [ngStyle]="field.dateStyles"
    [required]="field.required" [matDatepicker]="picker" [formControlName]="field.name" [placeholder]="field.label"
    [min]="field.date?.min" [max]="field.date?.max">
  <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
  <mat-datepicker #picker></mat-datepicker>
  <mat-hint></mat-hint>
  <ng-container *ngFor="let validation of field.validations;" ngProjectAs="mat-error">
    <mat-error *ngIf="group.get(field.name)?.hasError(validation.name)">{{validation.message}}</mat-error>
  </ng-container>
  <mat-error *ngIf="controlError">{{controlError}}</mat-error>

</mat-form-field>

<mat-form-field *ngIf="field.fieldType === 'datetime'" class="form-field" [formGroup]="group"
  [ngStyle]="field.containerStyles" [color]="field.color">
  <input matInput [gioEnableControl]="isEnabledFn(field.name, field.id)" [ngStyle]="field.dateStyles"
    [required]="field.required" type="datetime-local" [formControlName]="field.name" [placeholder]="field.label"
    [min]="field.date?.min" [max]="field.date?.max">
  <ng-container *ngFor="let validation of field.validations;" ngProjectAs="mat-error">
    <mat-error *ngIf="group.get(field.name)?.hasError(validation.name)">{{validation.message}}</mat-error>
  </ng-container>
</mat-form-field>
